// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__w1Tou","dragIcon":"SortableItem_dragIcon__IroZj","disabled":"SortableItem_disabled__3UD9n"};